/* Menu v2 — Mobile drill-down */

(function() {
  var MOBILE_QUERY = '(max-width: 767.98px)'
  var mq = window.matchMedia(MOBILE_QUERY)
  var initialized = false

  function i18n(key, fallback) {
    if (window.GS_I18N && window.GS_I18N[key]) return window.GS_I18N[key]
    return fallback
  }

  function getCategoryLabel($parent) {
    var $link = $parent.children('.main-menu__link').first()
    if ($link.length) {
      return $.trim($link.contents().filter(function() {
        return this.nodeType === 3
      }).text())
    }
    return ''
  }

  function buildBackButton(label) {
    var $btn = $('<button>', {
      type: 'button',
      class: 'main-menu__sub-menu__back',
      'aria-label': i18n('back', 'Retour') + ' — ' + label
    })
    $btn.append(document.createTextNode(label))
    return $btn
  }

  function buildScrollWrapper() {
    return $('<div>', {class: 'main-menu__sub-menu__scroll'})
  }

  function buildViewAll(href) {
    var $wrap = $('<div>', {class: 'main-menu__sub-menu__viewall'})
    $('<a>', {
      class: 'main-menu__sub-menu__viewall-btn',
      href: href,
      text: i18n('viewAll', 'Voir tout')
    }).appendTo($wrap)
    return $wrap
  }

  function decorateSubMenu($parent) {
    var $sub = $parent.children('.main-menu__sub-menu').first()
    if (!$sub.length || $sub.data('mobileReady')) return

    var label = getCategoryLabel($parent)
    var href = $parent.attr('data-href') || ''

    var $back = buildBackButton(label)
    var $scroll = buildScrollWrapper()

    /* Move existing children into scroll wrapper */
    $sub.children().each(function() {
      $scroll.append(this)
    })

    $sub.prepend($back)
    $sub.append($scroll)

    if (href) {
      $sub.append(buildViewAll(href))
      /* Drawer "Voir tout →" hint under the parent link */
      if (!$parent.children('.main-menu__item--voir-tout').length) {
        $('<a>', {
          class: 'main-menu__item--voir-tout',
          href: href,
          text: i18n('viewAll', 'Voir tout') + ' →'
        }).insertAfter($parent.children('.main-menu__link'))
      }
    }

    $sub.data('mobileReady', true)
  }

  function undecorateSubMenu($parent) {
    var $sub = $parent.children('.main-menu__sub-menu').first()
    if (!$sub.length || !$sub.data('mobileReady')) return

    var $scroll = $sub.children('.main-menu__sub-menu__scroll').first()
    if ($scroll.length) {
      $scroll.children().each(function() {
        $sub.append(this)
      })
      $scroll.remove()
    }
    $sub.children('.main-menu__sub-menu__back').remove()
    $sub.children('.main-menu__sub-menu__viewall').remove()
    $parent.children('.main-menu__item--voir-tout').remove()
    $sub.removeClass('main-menu__sub-menu--open')
    $sub.removeData('mobileReady')
  }

  function openPanel($parent) {
    var $sub = $parent.children('.main-menu__sub-menu').first()
    if (!$sub.length) return
    $sub.addClass('main-menu__sub-menu--open')
    $('body').addClass('has-mega-open')
  }

  function closeAllPanels() {
    $('.main-menu__sub-menu--open').removeClass('main-menu__sub-menu--open')
    $('body').removeClass('has-mega-open')
  }

  function onLinkCapture(e) {
    if (!mq.matches) return
    /* Stop the theme's .main-menu__link handler (index.js line 311) from closing the drawer */
    e.preventDefault()
    e.stopImmediatePropagation()
    e.stopPropagation()
    var $parent = $(e.currentTarget).parent('.main-menu__item--has-mega')
    decorateSubMenu($parent)
    openPanel($parent)
  }

  function bindEvents() {
    /* Capture-phase listener on each has-mega link to beat the theme's bubble-phase handler */
    $('.main-menu__item--has-mega > .main-menu__link').each(function() {
      this.addEventListener('click', onLinkCapture, true)
    })

    $(document)
      .off('click.menuV2Mobile')
      .on('click.menuV2Mobile', '.main-menu__sub-menu__back', function(e) {
        e.preventDefault()
        var $sub = $(this).closest('.main-menu__sub-menu')
        $sub.removeClass('main-menu__sub-menu--open')
        $('body').removeClass('has-mega-open')
      })
      .on('click.menuV2Mobile', 'button.burger', function() {
        if (!mq.matches) return
        closeAllPanels()
      })
  }

  function unbindEvents() {
    $('.main-menu__item--has-mega > .main-menu__link').each(function() {
      this.removeEventListener('click', onLinkCapture, true)
    })
    $(document).off('click.menuV2Mobile')
  }

  function enableMobile() {
    if (initialized) return
    $('.main-menu__item--has-mega').each(function() {
      decorateSubMenu($(this))
    })
    bindEvents()
    initialized = true
  }

  function disableMobile() {
    if (!initialized) return
    closeAllPanels()
    $('.main-menu__item--has-mega').each(function() {
      undecorateSubMenu($(this))
    })
    unbindEvents()
    initialized = false
  }

  /* --- Desktop : bouton X pour fermer le mega (le survol l'ouvre) --- */
  var desktopReady = false

  function buildCloseButton() {
    var $btn = $('<button>', {
      type: 'button',
      class: 'main-menu__sub-menu__close',
      'aria-label': i18n('close', 'Fermer')
    })
    $btn.html('&times;')
    return $btn
  }

  function enableDesktop() {
    if (desktopReady) return
    $('.main-menu__item--has-mega').each(function() {
      var $sub = $(this).children('.main-menu__sub-menu').first()
      if (!$sub.length || $sub.children('.main-menu__sub-menu__close').length) return
      $sub.prepend(buildCloseButton())
    })
    $(document)
      .off('click.menuV2Desktop')
      .on('click.menuV2Desktop', '.main-menu__sub-menu__close', function(e) {
        e.preventDefault()
        $(this).closest('.main-menu__item--has-mega').addClass('main-menu__item--dismissed')
      })
    /* Ne rouvre le mega qu'à un vrai survol de l'onglet (mouseenter du lien),
       jamais au moindre déplacement après la fermeture. */
    $('.main-menu__item--has-mega > .main-menu__link')
      .off('mouseenter.menuV2Desktop')
      .on('mouseenter.menuV2Desktop', function() {
        $(this).closest('.main-menu__item--has-mega').removeClass('main-menu__item--dismissed')
      })
    desktopReady = true
  }

  function disableDesktop() {
    if (!desktopReady) return
    $('.main-menu__sub-menu__close').remove()
    $('.main-menu__item--has-mega').removeClass('main-menu__item--dismissed')
    $('.main-menu__item--has-mega > .main-menu__link').off('mouseenter.menuV2Desktop')
    $(document).off('click.menuV2Desktop')
    desktopReady = false
  }

  function applyState() {
    if (mq.matches) {
      disableDesktop()
      enableMobile()
    } else {
      disableMobile()
      enableDesktop()
    }
  }

  /* --- Track top-bar height and expose it as --top-bar-height on <body> (load + resize) --- */
  function updateTopBarHeight() {
    var bar = document.querySelector('.top-bar')
    var h = bar ? bar.getBoundingClientRect().height : 0
    document.body.style.setProperty('--top-bar-height', h + 'px')
  }

  /* --- Pour chaque __sub-menu qui a un __footer, exposer --footer-space (height + margin-top) --- */
  function updateFooterSpaces() {
    var footers = document.querySelectorAll('.main-menu__sub-menu > .main-menu__sub-menu__footer')
    footers.forEach(function(footer) {
      var parent = footer.parentElement
      if (!parent) return
      var marginTop = parseFloat(getComputedStyle(footer).marginTop) || 0
      var height = footer.getBoundingClientRect().height
      parent.style.setProperty('--footer-space', (height + marginTop) + 'px')
    })
  }

  $(document).ready(function() {
    applyState()
    updateTopBarHeight()
    updateFooterSpaces()

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', applyState)
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(applyState)
    }

    var resizeRaf = null
    window.addEventListener('resize', function() {
      if (resizeRaf) cancelAnimationFrame(resizeRaf)
      resizeRaf = requestAnimationFrame(function() {
        updateTopBarHeight()
        updateFooterSpaces()
      })
    })
  })
})()
